export const arraySorter = <T>(
    items: T[],
    sortBy: keyof T = 'title' as keyof T,
    isAscend: boolean = true
) => {
    if (!items) {
        return null;
    }
    const sortValue = isAscend ? 1 : -1;
    const sortedItems = [...items].sort((a, b) => {
        let aValue: any = a[sortBy];
        let bValue: any = b[sortBy];
        if (aValue !== null && bValue === null) {
            return sortValue;
        }
        if (aValue === null && bValue !== null) {
            return sortValue * -1;
        }
        if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
        }
        return aValue >= bValue ? sortValue : sortValue * -1;
    });

    return sortedItems;
};

export const sortByValue = (a: { value: number }, b: { value: number }) => {
    if (a.value === undefined && b.value === undefined) {
        return 0;
    } else if (a.value === undefined) {
        return -1;
    } else if (b.value === undefined) {
        return 1;
    } else {
        return a.value - b.value;
    }
};
